import React from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../components/Contexts/AuthContext";
import { enterSandbox, sandboxUser, SandboxRole } from "./session";

// Entry screen for the sandbox. Replaces the login page: there are no
// accounts here, the visitor only chooses which role to explore.

const ROLES: { role: SandboxRole; title: string; body: string }[] = [
  {
    role: "user",
    title: "Technologist",
    body: "Claim systems, run checks, approve screenshots, open live view and add notes.",
  },
  {
    role: "admin",
    title: "Administrator",
    body: "Everything a technologist can do, plus users, systems, settings, billing and the audit log.",
  },
];

const SandboxGate: React.FC = () => {
  const auth = useAuth();
  const navigate = useNavigate();
  if (auth.isAuthenticated) return <Navigate to="/dashboard" replace />;

  const enter = (role: SandboxRole) => {
    enterSandbox(role);
    auth.login(sandboxUser(role) as any);
    navigate("/dashboard");
  };

  return (
    <div style={{ minHeight: "100vh", background: "#f1f5f9", display: "grid", placeItems: "center", padding: "24px 16px" }}>
      <div style={{ width: "min(720px, 100%)" }}>
        <div style={{ textAlign: "center", marginBottom: "28px" }}>
          <span style={{ display: "inline-block", background: "#eff6ff", border: "1px solid #bfdbfe", color: "#2563eb", borderRadius: "999px", padding: "4px 12px", fontSize: "12px", fontWeight: 700, letterSpacing: "0.06em", textTransform: "uppercase" }}>
            Sandbox
          </span>
          <h1 style={{ fontSize: "clamp(26px, 5vw, 36px)", fontWeight: 700, color: "#0f172a", margin: "14px 0 8px" }}>
            Try EpicareAlert
          </h1>
          <p style={{ color: "#64748b", fontSize: "16px", maxWidth: "520px", margin: "0 auto" }}>
            This is the real application running on simulated EEG systems. Nothing here is a real patient or a real
            workstation, and everything resets when you reload.
          </p>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: "16px" }}>
          {ROLES.map((r) => (
            <button
              key={r.role}
              onClick={() => enter(r.role)}
              style={{ textAlign: "left", background: "#ffffff", border: "1px solid #e2e8f0", borderRadius: "20px", padding: "24px", cursor: "pointer", boxShadow: "0 4px 24px rgba(0,0,0,0.08), 0 1px 4px rgba(0,0,0,0.04)" }}
            >
              <div style={{ fontSize: "18px", fontWeight: 700, color: "#0f172a", marginBottom: "6px" }}>{r.title}</div>
              <div style={{ fontSize: "14px", color: "#64748b", lineHeight: 1.5, marginBottom: "18px" }}>{r.body}</div>
              <span style={{ display: "inline-block", background: "#2563eb", color: "#ffffff", borderRadius: "10px", padding: "9px 16px", fontSize: "14px", fontWeight: 600 }}>
                Enter as {r.title.toLowerCase()}
              </span>
            </button>
          ))}
        </div>
        <p style={{ textAlign: "center", marginTop: "24px", fontSize: "13px" }}>
          <a href="https://epicarealert.com" style={{ color: "#64748b" }}>Back to epicarealert.com</a>
        </p>
      </div>
    </div>
  );
};

export default SandboxGate;
